var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GChart',{attrs:{"type":_vm.type,"data":_vm.data,"options":_vm.options,"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }